export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const SET_KEYCLOAK = 'SET_KEYCLOAK'
export const USER_INFO = 'USER_INFO'
export const MOBILE_URL = 'MOBILE_URL'
export const INIT_KEYCLOAK = 'INIT_KEYCLOAK'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const GET_RESERVATION = 'GET_RESERVATION'
export const SET_RESERVATION = 'SET_RESERVATION'
export const CREATE_RESERVATION = 'CREATE_RESERVATION'
export const DETAIL_RESERVATION = 'DETAIL_RESERVATION'
export const GET_ROOM_DAY = 'GET_ROOM_DAY'
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION'
export const SET_RUNNING = 'SET_RUNNING'
export const SET_POPUP_STATUS = 'SET_POPUP_STATUS'
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION'
export const CHECK_TOKEN_EXPIRE = 'CHECK_TOKEN_EXPIRE'
export const BYPASS_TOKEN = 'BYPASS_TOKEN'
export const SET_CONTEXT = 'SET_CONTEXT'
export const SET_CONFERENCE = 'SET_CONFERENCE'
export const GET_CONFERENCE = 'GET_CONFERENCE'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const GET_SUB_SCRIPTION = 'GET_SUB_SCRIPTION'
export const CANCEL_MEMBER_SHIP = 'CANCEL_MEMBER_SHIP'
export const SET_PAYMENT_HISTORY = 'SET_PAYMENT_HISTORY'
export const PAYMENT_HISTORY = 'PAYMENT_HISTORY'
export const GET_PACKAGE = 'GET_PACKAGE'
export const SET_CANCEL_MEMBER_SHIP = "SET_CANCEL_MEMBER_SHIP"
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const DESTROY_CONTEXT = 'DESTROY_CONTEXT'
export const SET_MESSAGE = 'SET_MESSAGE'
export const GET_MY_RECORDS_USAGE = 'GET_MY_RECORDS_USAGE'
export const SET_MY_RECORDS_USAGE = 'SET_MY_RECORDS_USAGE'
export const GET_CLOUD_RECORDS = 'GET_CLOUD_RECORDS'
export const SET_CLOUD_RECORDS = 'SET_CLOUD_RECORDS'
export const DELETE_CLOUD_RECORDS = 'DELETE_CLOUD_RECORDS'
export const DELETE_CLOUD_RECORDS_REQUEST = 'DELETE_CLOUD_RECORDS_REQUEST'
export const DELETE_CLOUD_RECORDS_SUCCESS = 'DELETE_CLOUD_RECORDS_SUCCESS'
export const DELETE_CLOUD_RECORDS_FAILURE = 'DELETE_CLOUD_RECORDS_FAILURE'
export const ADD_PACKAGE_LISTS = 'ADD_PACKAGE_LISTS'